import { type FC } from "react";

import errorSvg from "@app-assets/svg/error.svg";

import { Layout } from "./Layout";
import { Box, Content, HeadingContainer, Image, SubHeadingContainer } from "./Maintenance.styles";
import { PageSection } from "./PageSection";
import { TopNavigation } from "./TopNavigation";
import { Heading, SubHeading } from "./messages.generated";

export const Maintenance: FC = () => {
    return (
        <Layout>
            <TopNavigation />
            <Content>
                <PageSection>
                    <Box>
                        <Image src={errorSvg} />
                        <HeadingContainer>
                            <Heading />
                        </HeadingContainer>
                        <SubHeadingContainer>
                            <SubHeading />
                        </SubHeadingContainer>
                    </Box>
                </PageSection>
            </Content>
        </Layout>
    );
};
